import { render, staticRenderFns } from "./MonitoramentoConsumo.vue?vue&type=template&id=1aba3ca7&scoped=true"
import script from "./MonitoramentoConsumo.vue?vue&type=script&lang=js"
export * from "./MonitoramentoConsumo.vue?vue&type=script&lang=js"
import style0 from "./MonitoramentoConsumo.vue?vue&type=style&index=0&id=1aba3ca7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aba3ca7",
  null
  
)

export default component.exports